<div class="simulations-list">
  <div class="page-header">
    <p class="page-subtitle">
      {{ 'attackSimulationsPage.pageSubtitle' | labelsProvider }}
    </p>
    <button class="create-button" (click)="onCreateAssessment()">
      <lucide-icon name="plus" [size]="16" [strokeWidth]="2" />
      {{ 'attackSimulationsPage.newAssessmentButton' | labelsProvider }}
    </button>
  </div>

  <div class="search-bar">
    <div class="search-input-wrapper">
      <lucide-icon name="search" [size]="16" [strokeWidth]="2" class="search-icon" />
      <input
        type="text"
        class="search-input"
        [placeholder]="'attackSimulationsPage.searchPlaceholder' | labelsProvider"
        [ngModel]="searchTerm()"
        (ngModelChange)="onSearchChange($event)"
      />
    </div>
  </div>

  <div class="table-card">
    <div class="table-header">
      <span class="items-count"> {{ totalCount() }} assessments </span>
    </div>

    @if (isLoading()) {
      <div class="loading-container">
        <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="40" />
      </div>
    } @else if (filteredSessions().length === 0) {
      <div class="empty-state">
        <p class="empty-title">
          {{ 'attackSimulationsPage.emptyStateTitle' | labelsProvider }}
        </p>
        <p class="empty-message">
          {{ 'attackSimulationsPage.emptyStateMessage' | labelsProvider }}
        </p>
        <button class="empty-create-link" (click)="onCreateAssessment()">
          <lucide-icon name="plus" [size]="14" [strokeWidth]="2" />
          {{ 'attackSimulationsPage.newAssessmentButton' | labelsProvider }}
        </button>
      </div>
    } @else {
      <p-table
        [value]="filteredSessions()"
        [sortField]="'createdAt'"
        [sortOrder]="-1"
        [rowHover]="true"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="attackName" class="col-assessment">
              {{ 'attackSimulationsPage.columns.assessment' | labelsProvider }}
              <p-sortIcon field="attackName" />
            </th>
            <th pSortableColumn="aiService" class="col-ai-service">
              {{ 'attackSimulationsPage.columns.aiService' | labelsProvider }}
              <p-sortIcon field="aiService" />
            </th>
            <th pSortableColumn="attackStrategy" class="col-goal">
              {{ 'attackSimulationsPage.columns.attackStrategy' | labelsProvider }}
              <p-sortIcon field="attackStrategy" />
            </th>
            <th pSortableColumn="status" class="col-status">
              {{ 'attackSimulationsPage.columns.status' | labelsProvider }}
              <p-sortIcon field="status" />
            </th>
            <th pSortableColumn="resultsSortValue" class="col-results">
              {{ 'attackSimulationsPage.columns.results' | labelsProvider }}
              <p-sortIcon field="resultsSortValue" />
            </th>
            <th pSortableColumn="createdAt" class="col-created-at">
              {{ 'attackSimulationsPage.columns.lastRun' | labelsProvider }}
              <p-sortIcon field="createdAt" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-session>
          <tr class="session-row" (click)="onRowClick(session)">
            <td>{{ getAssessmentName(session) }}</td>
            <td>
              <span class="ai-service-cell">
                <img src="assets/images/logo/m365Copilot.svg" alt="" class="ai-service-icon" />
                {{ getAiServiceDisplay(session.aiService) }}
              </span>
            </td>
            <td>{{ formatAttackStrategy(session.attackStrategy) }}</td>
            <td>
              <app-simulation-status-badge [status]="session.status" />
            </td>
            <td>
              @if (isFinished(session) && !isFailed(session)) {
                <span
                  class="results-badge"
                  [class.results-found]="hasResults(session)"
                  [class.results-clean]="!hasResults(session)"
                >
                  <lucide-icon
                    [name]="hasResults(session) ? 'shield-alert' : 'shield-check'"
                    [size]="16"
                    [strokeWidth]="2"
                  />
                  {{ getResultsDisplay(session) }}
                </span>
              } @else {
                -
              }
            </td>
            <td>
              @if (isFinished(session)) {
                {{ session.createdAt | date: 'dd MMM, yyyy HH:mm' }}
              } @else {
                -
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>
